<template>
  <tr>
    <td>{{ task.id }}</td>
    <td>
      <img :src="get_logo_src(task.board_id)" />
    </td>
    <td>{{ get_vacancy(task.vacancy_id) }}</td>
    <td>{{ task.max_items_per_request }}</td>
    <td>{{ get_requests_per_day(task.request_per_day) }}</td>
    <td>{{ get_date(task.start_at) }} - {{ get_date(task.finish_at) }}</td>
    <td>{{ get_date(task.last_executed_at) || '' }}</td>
    <td>{{ get_date(task.next_execution_at) || '' }}</td>
    <td>
      <a class="dark-link" href="#" @click.prevent="toggle_modal(true)">{{
        $tr('admin.company.board.search.table.configure_filter')
      }}</a>

      <board-modal
        v-if="is_dialog_visible"
        :is_visible="is_dialog_visible"
        :citizenship_types="citizenship_types"
        :education_levels="education_levels"
        :employment_types="employment_types"
        :relocation_preferences="relocation_preferences"
        :job_functions="job_functions"
        :model="task"
        :vacancy_id_default="task.vacancy_id"
        :company-id="companyId"
        @toggle_nexxt_dialog="toggle_modal"
        @submit="update"
        @close="toggle_modal(false)"
      />
    </td>
  </tr>
</template>

<script>
  import moment from 'moment';
  import board_modal from './components/board_modal';
  import { STORE_PREFIX } from '../../constants.js';
  import { mapState } from 'vuex';

  export default {
    name: 'TaskRow',

    components: {
      board_modal
    },

    props: [
      'task',
      'citizenship_types',
      'education_levels',
      'employment_types',
      'job_functions',
      'relocation_preferences',
      'companyId'
    ],

    data() {
      return {
        is_dialog_visible: false,
        requests_per_days: [
          {
            id: 1,
            name: 'Once a day'
          },
          {
            id: 2,
            name: 'Twice a day'
          },
          {
            id: 96,
            name: '96'
          }
        ]
      };
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        vacancies: 'vacancies/list'
      }),

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      }
    },

    methods: {
      get_date(date) {
        if (!date) {
          return '';
        }
        return moment.unix(date).format(`${this.dateFormat} HH:mm`) || '';
      },

      toggle_modal(val) {
        this.is_dialog_visible = val;
      },

      update() {
        this.$emit('update');
        this.toggle_modal(false);
      },

      get_requests_per_day(val) {
        if (!val) {
          return '';
        }

        const request = this.requests_per_days.find(req => req.id === val);

        if (!request) {
          return '';
        }
        return request.name;
      },

      get_logo_src(board_id) {
        if (+board_id === 1) {
          return '/static/images/elements/nexxt.png';
        }
        return '';
      },

      get_vacancy(vacancy_id) {
        if (!this.vacancies || !this.vacancies.length) {
          return '';
        }
        const vacancy = this.vacancies.find(vacancy => +vacancy.id === +vacancy_id);
        return vacancy ? vacancy.name : '';
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.dark-link {
  // font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: #233346;

  &:hover {
    color: $green-hover;
  }

  &:focus,
  &:active {
    color: $green-active;
  }
}
</style>
